import {HStack, Text} from 'platform/foundation';

import {EMPTY_PLACEHOLDER, Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {isInvalidEmail} from '../../utils/isInvalidEmail';
import {InvalidEmailWarning} from '../InvalidEmailWarning/InvalidEmailWarning';

type EmailWithWarningProps = {
  email: string | Nullish;
  size?: 'base' | 'small' | 'xSmall';
} & TestIdProps;

/** A stored e-mail with a warning icon when the DMS API refuses it. */
export function EmailWithWarning(props: EmailWithWarningProps) {
  const email = (
    <Text size={props.size ?? 'xSmall'} data-testid={suffixTestId('email', props)}>
      {props.email ?? EMPTY_PLACEHOLDER}
    </Text>
  );

  // A valid e-mail keeps the plain text layout, so a long one still wraps as before
  return isInvalidEmail(props.email) ? (
    <HStack spacing={1} align="center">
      {email}
      <InvalidEmailWarning email={props.email} data-testid={props['data-testid']} />
    </HStack>
  ) : (
    email
  );
}
